import { useContext } from 'react';
import { SortAndReviewEventContext } from 'src/modules/alarm-processing/contexts/sort-and-review/provider';
import { SortAndReviewEventContextProps } from 'src/modules/alarm-processing/contexts/sort-and-review/types';

export function useSortReviewEvent(): SortAndReviewEventContextProps {
    return useContext(SortAndReviewEventContext);
}
